import { Stack, Divider, Box } from "@mui/material"
import React from "react"
import { ScaAmountEdit } from "./ScaAmountEdit"
import { ScaMethodEdit } from "./ScaMethodEdit"
import { ScaStatusEdit } from "./ScaStatusEdit"
import { ScaFiledEdit } from "./ScaFiledEdit"
import { ScaNotesEdit } from "./ScaNotesEdit"
import { ScaAgreementTypeEdit } from "./ScaAgreementTypeEdit"
import { useAppSelector } from "../../../../../app/hooks"

function SingleCaseAgreement() {
    const agreementType = useAppSelector(
        state => state.verification.verification.singleCaseAgreement?.agreementType
    );
    const showFields = agreementType === "SCA";
    const showStatus = agreementType && agreementType !== "Not Selected";
    const showNotes = agreementType !== "Not Selected";
    const fieldWidth = 220;
    return (
        <Box sx={{ maxWidth: 600, marginLeft: '16px', borderRadius: 3, p: 3, position: 'relative' }}>
            <Box mb={2}>
                <Box sx={{ minWidth: fieldWidth, maxWidth: fieldWidth, width: fieldWidth }}>
                    <ScaAgreementTypeEdit />
                </Box>
            </Box>
            <Divider sx={{ mb: 2, mt: -2, position: 'absolute', left: 0, right: 0, width: '100vw', minWidth: '100vw', marginLeft: '-16px', zIndex: 0 }} />
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                {showStatus && (
                    <Box mb={2}>
                        <Box sx={{ minWidth: fieldWidth, maxWidth: fieldWidth, width: fieldWidth }}>
                            <ScaStatusEdit />
                        </Box>
                    </Box>
                )}
                {showFields && (
                    <Stack direction='row' gap={2} mb={2}>
                        <ScaAmountEdit />
                        <ScaMethodEdit />
                        <ScaFiledEdit />
                    </Stack>
                )}
                {showFields && <Divider sx={{ my: 2 }} />}
                {showNotes && (
                    <React.Fragment>
                        <Box mb={1} color="text.secondary" fontSize={14} fontWeight={500}>
                            Notes
                        </Box>
                        <ScaNotesEdit />
                    </React.Fragment>
                )}
            </Box>
        </Box>
    );
}
export { SingleCaseAgreement }